import React from 'react';
import "./HomeAboutUs.css";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

import aboutus from "../../assets/imgs/aboutus.png";

function HomeAboutUs() {
  return (
    <div className="abusHom">
      <div className="maxW">
        <div className="abushMn">
          <div className="abusLft">
            <img src={aboutus} alt="aboutus" />
          </div>
          <div className="abusRyt">
            <h2>About Us</h2>
            <p>
              At Paytech Advisors, we are more than a consultancy — we are your strategic
              partner in growth. Specializing in payment solutions, business strategy,
              marketing, and technology, we help businesses navigate challenges and seize
              opportunities with clarity, confidence, and measurable results.
            </p>
            <p>
              Our philosophy is simple: <strong>we don’t sell, we solve</strong>. Every
              recommendation we make is grounded in deep market insight, operational
              expertise, and a commitment to your long-term success. Whether you need a
              seamless payment ecosystem, a winning market entry strategy, or cutting-edge
              tech solutions, we deliver with precision and purpose.
            </p>
            <div className="webBtns">
              <Button
                variant="contained"
                component={Link}
                to="/about-us"
                className="abbbtnLink"
              >
                Explore More
              </Button>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeAboutUs;
